export default __webpack_public_path__ + "1127e78d5d7524b0c0540de3d2a732b2.png";